import { LatinQuestionParticle } from "../LatinWord";

/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */

export const LATIN_QUESTION_PARTICLES: { [key: string]: LatinQuestionParticle } = {
  "-ne?": {
    type: "questionParticle",
    latin: "-ne?",
    dutch: "(wordt niet vertaald)"
  },
  "nōnne?": {
    type: "questionParticle",
    latin: "nōnne?",
    dutch: "toch wel?",
  },
  "num?": {
    type: "questionParticle",
    latin: "num?",
    dutch: "toch niet?",
  },
};

export function searchLatinQuestionParticle(key: keyof typeof LATIN_QUESTION_PARTICLES): LatinQuestionParticle {
  if (!(key in LATIN_QUESTION_PARTICLES)) {
    throw new Error(`No Latin question particle found for key: "${key}"`);
  }
  return LATIN_QUESTION_PARTICLES[key];
}